import React from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { Delete } from "@mui/icons-material";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import customImageStyles from "../../assets/jss/material-dashboard-react/components/customImageItemStyles";
import resources from "../../core/Localization/Localization";
import { useSelector } from "react-redux";
import ModalGallery from "../ModalGallery/ModalGallery";

const RequestImage = ({ image, height, title, handleDelete, buttons, index }) => {
    const images = useSelector((state) => state.partrequestImages.images);
    const [open, setOpen] = React.useState(false);
    const [openConfirm, setOpenConfirm] = React.useState(false);

    const modalGalleryImages = React.useMemo(() => {
        return images.map((image) => image.large_part_request_image_url);
    }, [images]);

    return (
        <>
            <Box
                position="relative"
                sx={customImageStyles.root}
                onClick={(e) => {
                    setOpen(true);
                }}
            >
                <img src={image?.medium_part_request_image_url} alt={title || ""} className={customImageStyles.img} height={height || 240} />
                <Box sx={customImageStyles.titleBar}>
                    <Typography sx={customImageStyles.title}>{title || ""}</Typography>
                    <Box sx={customImageStyles.buttonWrapper}>
                        {buttons}
                        {handleDelete ? (
                            <Tooltip title={resources.form.delete}>
                                <IconButton
                                    size="medium"
                                    variant="contained"
                                    color="secondary"
                                    aria-label={resources.form.delete}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setOpenConfirm(true);
                                    }}
                                >
                                    <Delete fontSize="inherit" />
                                </IconButton>
                            </Tooltip>
                        ) : null}
                    </Box>
                </Box>
            </Box>
            <ModalGallery images={modalGalleryImages} index={index} open={open} setOpen={setOpen} />
            <ConfirmationModal
                open={openConfirm}
                handleClose={() => setOpenConfirm(false)}
                title={resources.form.delete}
                text={resources.partRequests.deleteImage}
                onConfirmCallback={() => {
                    handleDelete();
                    setOpenConfirm(false);
                }}
                buttonLabel={resources.form.delete}
            />
        </>
    );
};

export default RequestImage;
